// we don't use new URL because it fails on bad base urls etc.
export function joinPath(...parts: string[]): string {
  return parts
    .map((part) => (part.endsWith('/') ? part.slice(0, -1) : part))
    .map((part) => (part.startsWith('/') ? part.slice(1) : part))
    .join('/');
}
